import { useI18n } from '@radical/locale'
import { LAYOUT } from '../basic'

const { t } = useI18n()

const screen: RouteRecordItem = {
  path: '/screen',
  name: 'Screen',
  component: LAYOUT,
  redirect: { name: 'ScreenStream' },
  meta: {
    orderNo: 7,
    icon: 'icon-park-solid:one-to-many',
    title: t('routes.screen.分屏播放'),
    hideChildrenInMenu: true,
  },
  children: [
    {
      path: 'stream',
      name: 'ScreenStream',
      component: () => import('@/pages/screen/stream.vue'),
      meta: {
        title: t('routes.screen.分屏播放'),
      },
    },
  ],
}

export default screen
